module.exports = __webpack_public_path__ + "static/img/2.72b833a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/2.png
// module id = xzVZ
// module chunks = 0